import createPrefixer from 'inline-style-prefixer/lib/createPrefixer';
import staticData from "./static";
var prefixAll = createPrefixer(staticData);
export default prefixAll;
export var prefixInlineStyles = function prefixInlineStyles(style) {
  var prefixedStyles = prefixAll(style);
  Object.keys(prefixedStyles).forEach(function (prop) {
    var value = prefixedStyles[prop];

    if (Array.isArray(value)) {
      prefixedStyles[prop] = value[value.length - 1];
    }
  });
  return prefixedStyles;
};